import {
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Collapse,
  Grid,
  Icon,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import i18n from "i18n/i18n";
import { useEffect, useState } from "react";
import photoPlaceholder from "assets/Svgs/photo-placeholder.svg";
import { ReactComponent as Magnifier } from "assets/Svgs/magnifier.svg";
import { Delete } from "@mui/icons-material";

import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import AttachmentIcon from "@mui/icons-material/Attachment";

import { v4 as uuidv4 } from "uuid";
import {
  allow_docs_mimetypes,
  allow_images_mimetypes,
  allow_videos_mimetypes,
  docs_enum,
  images_enum,
  videos_enum,
} from "utils/helper";
import mimee from "mime";
import UploadAttachmentModal from "./UploadAttachmentModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useBoundStore } from "store/store";

import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/styles.css";

interface Element {
  uuid: string;
  file: string;
}

interface DocElement {
  uuid: string;
  file: string;
  title: string;
  description: string;
  mimetype: string;
  url: string;
}

function EditFaq(props: any) {
  const deleteAttachment = useBoundStore((state) => state.deleteAttachment);
  const getSingleEquipment = useBoundStore((state) => state.getSingleEquipment);

  const loadNotificationDetails = useBoundStore(
    (state) => state.loadNotificationDetails
  );

  const lang: any = useBoundStore((state) => state.lang);

  const [title, setTitle] = useState(props?.question);
  const [description, setDescription] = useState(props?.answer);
  const [preImages, setPreImages] = useState([]);
  const [preVideos, setPreVideos] = useState([]);
  const [preDocs, setPreDocs] = useState([]);
  const [noti_loader, setnoti_loader] = useState(false);
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const updateFaq = useBoundStore((state) => state.updateFaq);

  const [navigate, setNavigate] = useState(false);
  const location = useLocation();
  const navigatee = useNavigate();

  const deleteSingleAttachment = async (id: any, uuid: any) => {
    setPreImages(preImages.filter((image: any) => image.uuid !== uuid));
    setPreVideos(preVideos.filter((image: any) => image.uuid !== uuid));
    const updatedElements = preDocs.filter(
      (element: any) => element.uuid !== uuid
    );
    setPreDocs(updatedElements);

    let toDeleteNodeid = props.questionanswernodeid;

    const promises: any[] = [deleteAttachment(id, toDeleteNodeid)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);

        getSingleEquipment(props.equipmentnodeid);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  };

  useEffect(() => {
    if (navigate) {
      if (props.from === "faq") {
        navigatee(
          "/machine-detail?nodeid=" +
            encodeURIComponent(props.equipmentnodeid) +
            "&tab=-1"
        );
        setTimeout(() => {
          navigatee(
            "/machine-detail?nodeid=" +
              encodeURIComponent(props.equipmentnodeid) +
              "&tab=3"
          );
        }, 1000);
      } else {
        navigatee(
          props.from && props.from == "notification"
            ? "/notification-details?nodeid=" +
                encodeURIComponent(props.notification?.nodeid)
            : "/equipmenttype-overview?nodeid=" +
                encodeURIComponent(props?.equipmentnodeid) +
                "&tab=2"
        );
      }
    }
  }, [navigate]);

  useEffect(() => {
    var images: any = [];
    var videos: any = [];
    var docs: any = [];
    if (
      props.questionanswerAttachments &&
      props.questionanswerAttachments.length > 0
    ) {
      props.questionanswerAttachments.map((i: any, k: any) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime?.split("/")[0])) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title !== null
              ? i?.attachment?.title[lang]
              : i?.attachment?.title,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    } else if (
      location.state &&
      location.state.questionanswerAttachments &&
      location.state.questionanswerAttachments.length > 0
    ) {
      location.state.questionanswerAttachments.map((i: any, k: any) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime?.split("/")[0])) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title !== null
              ? i?.attachment?.title[lang]
              : i?.attachment?.title,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    }

    return () => {
      // Unmount states
      if (!props.edit) {
        setPreImages([]);
        setPreVideos([]);
        setPreDocs([]);
      }
    };
  }, [props]);

  const [showMoreImages, setShowMoreImages] = useState(false);
  const [showMoreVideos, setShowMoreVideos] = useState(false);
  const [showMoreDocs, setShowMoreDocs] = useState(false);

  const [localImages, setLocalImages] = useState<any[]>([]);
  const [localVideos, setLocalVideos] = useState<any[]>([]);
  const [localDocs, setLocalDocs] = useState<any[]>([]);

  const [isDocModelOpen, setIsDocModelOpen] = useState(false);

  const [docTitle, setDocTitle] = useState("");
  const [docDescription, setDocDescription] = useState("");
  const [docTarget, setDocTarget] = useState();

  const [docFile, setDocFile] = useState();

  // Function to add a new element to the array
  const addLocalImage = (e: any) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }

    var image = file
      ? new File([file], file.name, {
          type: file.type,
        })
      : null;
    var localURL: any = image ? URL.createObjectURL(image) : null;

    setLocalImages([
      ...localImages,
      {
        attachment: {
          uuid: uuidv4(),
          file: {
            localuri: localURL,
            mimetype: file?.type || "", // Use a default value if file?.type is undefined
          },
        },
      },
    ]);
  };

  const addLocalVideo = (e: any) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }

    var video = file
      ? new File([file], file.name, {
          type: file.type,
        })
      : null;
    var localURL: any = video ? URL.createObjectURL(video) : null;

    setLocalVideos([
      ...localVideos,
      {
        attachment: {
          uuid: uuidv4(),
          file: {
            localuri: localURL,
            mimetype: file?.type || "", // Use a default value if file?.type is undefined
          },
        },
      },
    ]);
  };

  const addLocalDocs = (e: any) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }
    var doc = file
      ? new File([file], file.name, {
          type: file.type,
        })
      : null;
    var localURL: any = doc ? URL.createObjectURL(doc) : null;
    setLocalDocs([
      ...localDocs,
      {
        attachment: {
          uuid: uuidv4(),
          url: localURL,
          title: docTitle,
          description: docDescription,
          mimetype: file?.type || "", // Use a default value if file?.type is undefined
          file: {
            localuri: localURL,
            mimetype: file?.type || "", // Use a default value if file?.type is undefined
          },
        },
      },
    ]);

    setIsDocModelOpen(false);
    setDocFile(undefined);
    setDocTitle("");
    setDocDescription("");
  };
  // Function to remove an element from the array
  const deleteLocalImage = (id: any) => {
    const updatedElements = localImages.filter(
      (element) => element.attachment.uuid !== id
    );
    setLocalImages(updatedElements);
  };

  const deleteSingleVideo = (id: any) => {
    const updatedElements = localVideos.filter(
      (element) => element.attachment.uuid !== id
    );
    setLocalVideos(updatedElements);
  };

  const deleteSingleDocs = (id: any) => {
    const updatedElements = localDocs.filter((element) => element.uuid !== id);
    setLocalDocs(updatedElements);
  };

  const handleShowMoreImages = () => {
    setShowMoreImages((prev) => !prev);
  };

  const handleShowMoreVideos = () => {
    setShowMoreVideos((prev) => !prev);
  };

  const handleShowMoreDocs = () => {
    setShowMoreDocs((prev) => !prev);
  };

  const docModalClose = () => {
    setIsDocModelOpen(false);
  };

  const submitForm = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    setnoti_loader(true);

    if (props.from == "faq") {
      if (props?.from == "faq" && props?.pageType == "edit") {
        const obj: any = {
          attachmentType: "Create",
          question: title,
          answer: description,
          questionanswernodeid: props?.questionanswernodeid,
          lang: lang,
          nodeid: props?.questionanswernodeid,
          attachments: [...localImages, ...localDocs, ...localVideos],
        };

        const promises = await updateFaq(obj);
        if (isAuthUser === true) {
          try {
            const result = await Promise.all(promises);
          } catch (error) {
            console.error("Error during promise execution:", error);
          }
        }
      }
    }

    setnoti_loader(false);
    setLocalImages([]);
    setLocalDocs([]);
    setLocalVideos([]);
    setNavigate(true);
  };

  const [open, setOpen] = useState(false);
  const [lightBoxUrl, setLightBoxUrl] = useState("");

  const onImgClick = (e: any, url: any) => {
    e.preventDefault();
    setOpen(true);
    setLightBoxUrl(url);
  };

  const subscribedEquipments = useBoundStore(
    (state) => state.subscribedEquipments
  );
  let questionanswerAttachments =
    subscribedEquipments?.equipment?.hasquestionanswer[props.index]
      ?.questionanswer.hasattachment;

  return (
    <div>
      {open && (
        <Lightbox
          open={open}
          close={() => {
            setOpen(false);
          }}
          slides={[{ src: lightBoxUrl }]}
          plugins={[Download]}
        />
      )}

      <section>
        <div>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={9}>
                <TextField
                  sx={{ marginTop: "24px" }}
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                  fullWidth
                  defaultValue={props?.question}
                  placeholder={i18n(lang)?.faq_question}
                  variant="outlined"
                  error={title === "" || title === undefined}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={9}>
                <TextField
                  multiline
                  fullWidth
                  sx={{ marginTop: "24px" }}
                  rows="5"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  label={i18n(lang)?.answer}
                  placeholder={i18n(lang)?.faq_answer}
                  variant="outlined"
                  defaultValue={props?.answer}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12}></Grid>
            </Grid>

            {/* Images */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={9}>
                  {preImages.length ? (
                    <>
                      <div
                        className="generalHeading"
                        style={{ marginTop: "10px" }}
                      >
                        {i18n(lang)?.heading_photos}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {preImages &&
                          preImages.length > 0 &&
                          preImages.slice(0, 3)?.map((i: any, e) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "12px 12px 12px 0px",
                                  position: "relative",
                                }}
                                key={i.uuid}
                              >
                                <button className="mediaWrapper bxShadow">
                                  <img
                                    src={i.url}
                                    alt={i18n(lang)?.image_here}
                                    className="string"
                                  />
                                  <div className="magnifier">
                                    <Magnifier
                                      onClick={(e) => {
                                        onImgClick(e, i.url);
                                      }}
                                    />
                                  </div>
                                </button>
                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

<br/>
                  {preImages.length > 3 ? (
                    <div onClick={handleShowMoreImages} className="showMore">
                      <div>
                        {i18n(lang)?.show_n_more.replace(
                          "%s",
                          "" + preImages.slice(3).length
                        )}
                      </div>{" "}
                      <div className="icon">
                        {" "}
                        {showMoreImages ? (
                          <ExpandLessRoundedIcon />
                        ) : (
                          <ExpandMoreRoundedIcon />
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {preImages.length > 3 ? (
                    <>
                      <Collapse
                        in={showMoreImages}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div
                          className={"uploadedMediaContainer"}
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          {preImages.slice(3)?.map((i: any, e) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "12px 12px 12px 0px",
                                  position: "relative",
                                }}
                                key={i.uuid}
                              >
                                <button className="mediaWrapper bxShadow">
                                  <img
                                    src={i.url}
                                    alt={i18n(lang)?.image_here}
                                    className="string dog"
                                  />
                                  <div className="magnifier">
                                    <Magnifier
                                      onClick={(e) => {
                                        onImgClick(e, i.url);
                                      }}
                                    />
                                  </div>
                                </button>
                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </Collapse>
                    </>
                  ) : (
                    ""
                  )}

                  {localImages.length ? (
                    <div
                      className={"uploadedMediaContainer"}
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {localImages.map((i, e) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              margin: "12px 12px 12px 0px",
                              position: "relative",
                            }}
                            key={i?.attachment?.uuid}
                          >
                            <button className="mediaWrapper bxShadow">
                              <img
                                src={i?.attachment?.file.localuri}
                                alt={i18n(lang)?.image_here}
                                className="string"
                              />
                              <div className="magnifier">
                                <Magnifier
                                  onClick={(e) => {
                                    onImgClick(e, i.attachment?.file.localuri);
                                  }}
                                />
                              </div>
                            </button>

                            <IconButton
                              className={"deleteButton"}
                              onClick={() =>
                                deleteLocalImage(i?.attachment?.uuid)
                              }
                            >
                              <Delete />
                            </IconButton>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}

                  <Card
                    className={"cardButton"}
                    variant="outlined"
                    sx={{ marginTop: "24px" }}
                  >
                    <input
                      id="myInput"
                      style={{ display: "none" }}
                      accept={images_enum}
                      type="file"
                      onChange={addLocalImage}
                    />
                    <CardActionArea>
                      <label htmlFor="myInput">
                        <CardHeader
                          className="NT_cardHeader"
                          avatar={
                            <Icon color="primary" className={"cardIcon"}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_3115_10382"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                >
                                  <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_3115_10382)">
                                  <path
                                    d="M11 18.5C12.25 18.5 13.3127 18.0627 14.188 17.188C15.0627 16.3127 15.5 15.25 15.5 14C15.5 12.75 15.0627 11.6873 14.188 10.812C13.3127 9.93733 12.25 9.5 11 9.5C9.75 9.5 8.68733 9.93733 7.812 10.812C6.93733 11.6873 6.5 12.75 6.5 14C6.5 15.25 6.93733 16.3127 7.812 17.188C8.68733 18.0627 9.75 18.5 11 18.5ZM3 22C2.45 22 1.97933 21.8043 1.588 21.413C1.196 21.021 1 20.55 1 20V8C1 7.45 1.196 6.97933 1.588 6.588C1.97933 6.196 2.45 6 3 6H6.15L7.4 4.65C7.58333 4.45 7.804 4.29167 8.062 4.175C8.32067 4.05833 8.59167 4 8.875 4H13C13.2833 4 13.521 4.09567 13.713 4.287C13.9043 4.479 14 4.71667 14 5V8H3V20H19V11H20C20.1333 11 20.2627 11.025 20.388 11.075C20.5127 11.125 20.621 11.1957 20.713 11.287C20.8043 11.379 20.875 11.4873 20.925 11.612C20.975 11.7373 21 11.8667 21 12V20C21 20.55 20.8043 21.021 20.413 21.413C20.021 21.8043 19.55 22 19 22H3ZM19 6H18C17.7167 6 17.4793 5.90433 17.288 5.713C17.096 5.521 17 5.28333 17 5C17 4.71667 17.096 4.479 17.288 4.287C17.4793 4.09567 17.7167 4 18 4H19V3C19 2.71667 19.096 2.479 19.288 2.287C19.4793 2.09567 19.7167 2 20 2C20.2833 2 20.5207 2.09567 20.712 2.287C20.904 2.479 21 2.71667 21 3V4H22C22.2833 4 22.5207 4.09567 22.712 4.287C22.904 4.479 23 4.71667 23 5C23 5.28333 22.904 5.521 22.712 5.713C22.5207 5.90433 22.2833 6 22 6H21V7C21 7.28333 20.904 7.521 20.712 7.713C20.5207 7.90433 20.2833 8 20 8C19.7167 8 19.4793 7.90433 19.288 7.713C19.096 7.521 19 7.28333 19 7V6Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </g>
                              </svg>
                            </Icon>
                          }
                          title={i18n(lang)?.button_upload_photo}
                        />
                      </label>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* Videos */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={9}>
                  {preVideos.length ? (
                    <>
                      <div
                        className="generalHeading"
                        style={{ marginTop: "10px" }}
                      >
                        {i18n(lang)?.heading_videos}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {preVideos &&
                          preVideos.length > 0 &&
                          preVideos.slice(0, 3)?.map((i: any, e) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "12px 12px 12px 0px",
                                  position: "relative",
                                }}
                                key={i?.uuid}
                              >
                                <button className="mediaWrapper bxShadow">
                                  <video controls width="100%" height="100%">
                                    <source src={i?.url} />
                                    {i18n(lang)?.browser_doesnot_support}
                                  </video>
                                </button>

                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

<br/>
                  {preVideos.length > 3 ? (
                    <div onClick={handleShowMoreVideos} className="showMore">
                      <div>
                        {i18n(lang)?.show_n_more.replace(
                          "%s",
                          "" + preVideos.slice(3).length
                        )}
                      </div>{" "}
                      <div className="icon">
                        {" "}
                        {showMoreVideos ? (
                          <ExpandLessRoundedIcon />
                        ) : (
                          <ExpandMoreRoundedIcon />
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {preVideos.length > 3 ? (
                    <>
                      <Collapse
                        in={showMoreVideos}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div
                          className={"uploadedMediaContainer"}
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          {preVideos.slice(3)?.map((i: any, e) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "12px 12px 12px 0px",
                                  position: "relative",
                                }}
                                key={i.uuid}
                              >
                                <button className="mediaWrapper bxShadow">
                                  <video controls width="100%" height="100%">
                                    <source src={i.sources} />
                                    {i18n(lang)?.browser_doesnot_support}
                                  </video>
                                </button>

                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </Collapse>
                    </>
                  ) : (
                    ""
                  )}

                  {localVideos.length ? (
                    <div
                      className={"uploadedMediaContainer"}
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {localVideos.map((i, e) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              margin: "12px 12px 12px 0px",
                              position: "relative",
                            }}
                            key={i?.attachment?.uuid}
                          >
                            <button className="mediaWrapper bxShadow">
                              <video controls width="100%" height="100%">
                                <source src={i?.attachment?.file?.localuri} />
                                {i18n(lang)?.browser_doesnot_support}
                              </video>
                            </button>

                            <IconButton
                              className={"deleteButton"}
                              onClick={() =>
                                deleteSingleVideo(i?.attachment?.uuid)
                              }
                            >
                              <Delete />
                            </IconButton>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}

                  <Card
                    className={"cardButton"}
                    variant="outlined"
                    sx={{ marginTop: "24px" }}
                  >
                    <input
                      id="myInput1"
                      style={{ display: "none" }}
                      accept={videos_enum}
                      type="file"
                      onChange={addLocalVideo}
                    />
                    <CardActionArea>
                      <label htmlFor="myInput1">
                        <CardHeader
                          className="NT_cardHeader"
                          avatar={
                            <Icon color="primary" className={"cardIcon"}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_3115_10580"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                  style={{ maskType: "alpha" }}
                                >
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="#D9D9D9"
                                  ></rect>
                                </mask>
                                <g mask="url(#mask0_3115_10580)">
                                  <path
                                    d="M10 16C10.2833 16 10.5208 15.9042 10.7125 15.7125C10.9042 15.5208 11 15.2833 11 15V13H13C13.2833 13 13.5208 12.9042 13.7125 12.7125C13.9042 12.5208 14 12.2833 14 12C14 11.7167 13.9042 11.4792 13.7125 11.2875C13.5208 11.0958 13.2833 11 13 11H11V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13H9V15C9 15.2833 9.09583 15.5208 9.2875 15.7125C9.47917 15.9042 9.71667 16 10 16ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H16C16.55 4 17.0208 4.19583 17.4125 4.5875C17.8042 4.97917 18 5.45 18 6V10.5L21.15 7.35C21.3 7.2 21.4792 7.1625 21.6875 7.2375C21.8958 7.3125 22 7.46667 22 7.7V16.3C22 16.5333 21.8958 16.6875 21.6875 16.7625C21.4792 16.8375 21.3 16.8 21.15 16.65L18 13.5V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H4ZM4 18H16V6H4V18Z"
                                    fill="black"
                                    fill-opacity="0.5"
                                  ></path>
                                </g>
                              </svg>
                            </Icon>
                          }
                          title={i18n(lang)?.button_upload_video}
                        />
                      </label>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* Docs */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={9}>
                  {preDocs.length ? (
                    <>
                      <div
                        className="generalHeading"
                        style={{ marginTop: "10px" }}
                      >
                        {i18n(lang)?.heading_docs}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {preDocs &&
                          preDocs.length > 0 &&
                          preDocs.slice(0, 3)?.map((i: any, e) => {
                            let mimeType = mimee?.getExtension(i?.mimetype);
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "12px 12px 12px 0px",
                                }}
                                key={i?.uuid}
                              >
                                <Card
                                  className={"cardButtonLarge"}
                                  variant="outlined"
                                  onClick={() => {
                                    window.open(i?.url, "PDF Viewer");
                                  }}
                                >
                                  <CardActionArea
                                    sx={{
                                      border: "1px solid rgba(0, 0, 0, 0.12)",
                                    }}
                                  >
                                    <CardHeader
                                      avatar={
                                        <Icon
                                          color="primary"
                                          className={"cardIcon"}
                                        >
                                          <AttachmentIcon />
                                        </Icon>
                                      }
                                      style={{ height: "70px" }}
                                      subheader={
                                        <div className="attachmentWrapper">
                                          <div className="content">
                                            <div className="attachmentHeader">
                                              {i?.title
                                                ? i?.title
                                                : i18n(lang)
                                                    ?.no_workflow_title}{" "}
                                              <span
                                                style={{ marginLeft: "2px" }}
                                                className="mimeType"
                                              >
                                                {mimeType
                                                  ? mimeType
                                                  : "no_type"}{" "}
                                              </span>
                                            </div>
                                            <div
                                              className="attachmentSubHeader"
                                              style={{ width: "max-content" }}
                                            >
                                              {i?.description
                                                ? i?.description
                                                : ""}{" "}
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    />
                                  </CardActionArea>
                                </Card>
                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {preDocs.length > 3 ? (
                    <div onClick={handleShowMoreDocs} className="showMore">
                      <div>
                        {i18n(lang)?.show_n_more.replace(
                          "%s",
                          "" + preDocs.slice(3).length
                        )}
                      </div>{" "}
                      <div className="icon">
                        {" "}
                        {showMoreDocs ? (
                          <ExpandLessRoundedIcon />
                        ) : (
                          <ExpandMoreRoundedIcon />
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  { preDocs.length > 3 ? (
                    <>
                      <Collapse in={showMoreDocs} timeout="auto" unmountOnExit>
                        <div
                          className={"uploadedMediaContainer"}
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          {preDocs.slice(3)?.map((i: any, e) => {
                            let mimeType = mimee?.getExtension(i?.mimetype);
                            return (
                              <div
                                style={{ display: "flex", margin: "12px" }}
                                key={i?.uuid}
                              >
                                <Card
                                  className={"cardButtonLarge"}
                                  variant="outlined"
                                  onClick={() => {
                                    window.open(i?.url, "PDF Viewer");
                                  }}
                                >
                                  <CardActionArea
                                    sx={{
                                      border: "1px solid rgba(0, 0, 0, 0.12)",
                                    }}
                                  >
                                    <CardHeader
                                      avatar={
                                        <Icon
                                          color="primary"
                                          className={"cardIcon"}
                                        >
                                          <AttachmentIcon />
                                        </Icon>
                                      }
                                      style={{ height: "70px" }}
                                      subheader={
                                        <div className="attachmentWrapper">
                                          <div className="content">
                                            <div className="attachmentHeader">
                                              {i.title
                                                ? i.title
                                                : i18n(lang)
                                                    ?.no_workflow_title}{" "}
                                              <span
                                                style={{ marginLeft: "2px" }}
                                                className="mimeType"
                                              >
                                                {mimeType
                                                  ? mimeType
                                                  : "no_type"}{" "}
                                              </span>
                                            </div>
                                            <div
                                              className="attachmentSubHeader"
                                              style={{ width: "max-content" }}
                                            >
                                              {i.description
                                                ? i.description
                                                : ""}{" "}
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    />
                                  </CardActionArea>
                                </Card>
                                {props?.edit ? (
                                  <IconButton
                                    onClick={() => {
                                      deleteSingleAttachment(
                                        i?.nodeid,
                                        i?.uuid
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </Collapse>
                    </>
                  ) : (
                    ""
                  )}

                  {localDocs.length ? (
                    <div
                      className={"uploadedMediaContainer"}
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {localDocs.map((i, e) => {
                        let mimeType = mimee?.getExtension(
                          i?.attachment?.mimetype
                        );
                        return (
                          <div
                            style={{ display: "flex", margin: "12px 0px" }}
                            key={i?.attachment?.uuid}
                          >
                            <Card
                              className={"cardButtonLarge"}
                              variant="outlined"
                              onClick={() => {
                                window.open(i?.attachment?.url, "PDF Viewer");
                              }}
                            >
                              <CardActionArea
                                sx={{
                                  border: "1px solid rgba(0, 0, 0, 0.12)",
                                }}
                              >
                                <CardHeader
                                  avatar={
                                    <Icon
                                      color="primary"
                                      className={"cardIcon"}
                                    >
                                      <AttachmentIcon />
                                    </Icon>
                                  }
                                  style={{ height: "70px" }}
                                  subheader={
                                    <div className="attachmentWrapper">
                                      <div className="content">
                                        <div className="attachmentHeader">
                                          {i?.attachment?.title
                                            ? i?.attachment?.title
                                            : i18n(lang)
                                                ?.no_workflow_title}{" "}
                                          <span
                                            style={{ marginLeft: "2px" }}
                                            className="mimeType"
                                          >
                                            {mimeType ? mimeType : "no_type"}{" "}
                                          </span>
                                        </div>
                                        <div
                                          className="attachmentSubHeader"
                                          style={{ width: "max-content" }}
                                        >
                                          {i?.attachment?.description
                                            ? i?.attachment?.description
                                            : ""}{" "}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                />
                              </CardActionArea>
                            </Card>

                            <IconButton
                              className={"deleteButton"}
                              onClick={() =>
                                deleteSingleDocs(i?.attachment?.uuid)
                              }
                              style={{ marginBottom: 8 }}
                            >
                              <Delete />
                            </IconButton>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}

                  <Card
                    className={"cardButton"}
                    variant="outlined"
                    sx={{ marginTop: "24px" }}
                    onClick={() => {
                      setIsDocModelOpen(true);
                    }}
                  >
                    <CardActionArea>
                      <label htmlFor="myInput2">
                        <CardHeader
                          className="NT_cardHeader"
                          avatar={
                            <Icon color="primary" className={"cardIcon"}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_3115_10854"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                  style={{ maskType: "alpha" }}
                                >
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="#D9D9D9"
                                  ></rect>
                                </mask>
                                <g mask="url(#mask0_3115_10854)">
                                  <path
                                    d="M7.5 17.5C5.96667 17.5 4.66667 16.9667 3.6 15.9C2.53333 14.8333 2 13.5333 2 12C2 10.4667 2.53333 9.16667 3.6 8.1C4.66667 7.03333 5.96667 6.5 7.5 6.5H18C19.1 6.5 20.0417 6.89167 20.825 7.675C21.6083 8.45833 22 9.4 22 10.5C22 11.6 21.6083 12.5417 20.825 13.325C20.0417 14.1083 19.1 14.5 18 14.5H8.5C7.8 14.5 7.20833 14.2583 6.725 13.775C6.24167 13.2917 6 12.7 6 12C6 11.3 6.24167 10.7083 6.725 10.225C7.20833 9.74167 7.8 9.5 8.5 9.5H17.25C17.4667 9.5 17.646 9.57067 17.788 9.712C17.9293 9.854 18 10.0333 18 10.25C18 10.4667 17.9293 10.6457 17.788 10.787C17.646 10.929 17.4667 11 17.25 11H8.5C8.21667 11 7.97933 11.0957 7.788 11.287C7.596 11.479 7.5 11.7167 7.5 12C7.5 12.2833 7.596 12.5207 7.788 12.712C7.97933 12.904 8.21667 13 8.5 13H18C18.7 13 19.2917 12.7583 19.775 12.275C20.2583 11.7917 20.5 11.2 20.5 10.5C20.5 9.8 20.2583 9.20833 19.775 8.725C19.2917 8.24167 18.7 8 18 8H7.5C6.4 8 5.45833 8.39167 4.675 9.175C3.89167 9.95833 3.5 10.9 3.5 12C3.5 13.1 3.89167 14.0417 4.675 14.825C5.45833 15.6083 6.4 16 7.5 16H17.25C17.4667 16 17.646 16.0707 17.788 16.212C17.9293 16.354 18 16.5333 18 16.75C18 16.9667 17.9293 17.146 17.788 17.288C17.646 17.4293 17.4667 17.5 17.25 17.5H7.5Z"
                                    fill="black"
                                    fill-opacity="0.5"
                                  ></path>
                                </g>
                              </svg>
                            </Icon>
                          }
                          title={i18n(lang)?.button_upload_attachment}
                        />
                      </label>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ maxWidth: 475 }}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={noti_loader || (props?.from === "faq" && title === "") || (props?.from === "faq" && title === undefined)}
                  onClick={submitForm}
                  style={{ textTransform: "none", marginTop: "20px" }}
                >
                  {i18n(lang)?.save_FAQ}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>

      <UploadAttachmentModal
        hasTitle
        hasDescription
        open={isDocModelOpen}
        customFileChange={props.customFileChange}
        onClose={docModalClose}
        file={docFile}
        setFile={setDocFile}
        handleSubmit={addLocalDocs}
        description={docDescription}
        setDescription={setDocDescription}
        title={docTitle}
        setTitle={setDocTitle}
        setTarget={setDocTarget}
        target={docTarget}
        allowedExts={docs_enum}
        showActions
        fromDoc
      />
    </div>
  );
}

export default EditFaq;
